import { Form } from 'react-bootstrap'
import { Designed, PromiseVoid } from 'web_core/types'

export type QueryOrder = 'created_at desc' | 'score desc'

type Props = {
  order: QueryOrder
  onChange: (currentValue: QueryOrder) => PromiseVoid
}

export const QueryOrderSelector = ({
  order,
  onChange: handleChange,
  ...otherProps
}: Designed<Props>) => {
  return (
    <Form.Select
      {...otherProps}
      onChange={(e) => handleChange(e.currentTarget.value as QueryOrder)}
    >
      <option value={'created_at desc'} selected={order === 'created_at desc'}>
        作成日順
      </option>
      <option value={'score desc'} selected={order === 'score desc'}>
        評価順
      </option>
    </Form.Select>
  )
}
